var map = {
	"./banque-populaire.png": "e61f",
	"./caisse-epargne.png": "ba13",
	"./canap.png": "043c",
	"./cic.png": "d4ac",
	"./lbc.png": "63ab",
	"./lbp.png": "2fe0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5607";